import { Singleton } from 'framework/di';

import type {
  BundleTemplateName,
  PredictiveBundleDefaultSettings,
} from './predictive-bundle.model';

@Singleton()
export class PredictiveBundleConstants {
  readonly PREDICTIVE_BUNDLE_TYPE = 'dynamic-bundle';
  readonly KEY_PREDICTIVE_BUNDLE = 'dynamicBundleKey';

  readonly KEYBOARD_ACTIVATION_KEYS: readonly string[] = ['Enter', ' ', 'Spacebar'];

  readonly SELECTORS = {
    PRE_FIX_CLASS_PREDICTIVE_BUNDLE_MODAL: 'boost-sd__dynamic-bundle-modal-',
    MODAL_WRAPPER: '.boost-sd__modal-wrapper',
    RECOMMENDATION: '.boost-sd__recommendation',
    PREDICTIVE_BUNDLE_ID_CONTAINER_SEARCH_PAGE: 'boost-sd__dynamic-bundle-search-page',
    EMBEDDED_BUNDLE_ID_CONTAINER_PRODUCT: 'boost-sd__embedded-bundle-product',
    CHECK_BOX: '.boost-sd__recommendation-bundle-checkbox',
    CHECK_BOX_BUTTON: '.boost-sd__recommendation-bundle-checkbox-box',
    DROPDOWN_ITEM: '.boost-sd__dropdown-dynamic-item',
    BUNDLE_IMAGE_ITEM: '.boost-sd__recommendation-bundle-image-item',
    PREDICTIVE_BUNDLE_SHOW_POPUP: '.boost-sd__recommendation-dynamic-show-popup',
    BUTTON_ADD_BUNDLE_TO_CART: '.boost-sd__btn-add-to-cart',
    PREDICTIVE_BUNDLE_BLOCK: '.boost-sd-widget-predictive-bundle',
  } as const;

  readonly CSS_CLASSES = {
    DROPDOWN_LIST: 'boost-sd__dropdown-option-list',
    DROPDOWN_LIST_OPEN: 'boost-sd__dropdown-option-list--open',
    DROPDOWN_SELECT_OPTION: 'boost-sd__dropdown-selected-option',
    DROPDOWN_CONTAINER: 'boost-sd__dropdown-dynamic',
    DROPDOWN_SELECT_OPTION_SELECTED: 'boost-sd__dropdown-option--selected',
  } as const;

  readonly BUNDLE_ACTION = {
    initData: 'init-data',
    changeVariant: 'change-variant',
    clickCheckbox: 'click-checkbox',
  } as const;

  readonly BUNDLE_TEMPLATE_NAME: Record<'dynamic' | 'embedded', BundleTemplateName> = {
    dynamic: 'recommendationDynamicBundle',
    embedded: 'recommendationEmbeddedBundle',
  } as const;

  readonly SESSION_KEYS = {
    DATA_SESSION: 'DynamicBundleDataSession',
    OPENING: 'DynamicBundleOpening',
    CHECKBOX: 'DynamicBundleCheckBox',
    COMBOBOX_BUTTON: 'DynamicBundleComboBox',
  } as const;

  readonly DEFAULT_SETTINGS: PredictiveBundleDefaultSettings = {
    titleName: 'Buy more and save',
    templateType: 'default',
    titleAlignment: 'center',
    titleTextColor: '#3D4246',
    titleFont: 'Poppins',
    titleTextTransform: 'capitalize',
    titleFontStyle: 'regular',
    titleFontSize: 14,
    buttonBackgroundColor: '#111111',
    buttonText: 'Add bundle to cart',
    buttonTextColor: '#FFFFFF',
    isDefault: false,
  };
}
